import axios from "axios";
import qs from "qs";
import { MessageBox } from "element-ui";
import Vue from "vue";
// import { appConfig } from "../../public/js/getSn";

// var baseURL = '/api';
// var baseURL = "http://255l579g29.vicp.fun"
// var baseURL = "/api/"
var baseURL = "/" //正式环境
// http://8.145.34.230:8099/
// var baseURL = 'http://47.97.56.208/api/';
// var baseURL = 'http://117.40.198.115:8026/';
// var baseURL ='';
// const token = "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJhZG1pbiIsImxvZ2luX3VzZXJfa2V5IjoiMzc1YmJhODktYjA5NS00Y2EyLWI4ZDktN2U2Y2M4NmIwNmVjIn0.4TCp4Np7HIFHMTrBcSBu9tmvTUdBg4yQNRPP-IgDP381Bn-ghmSlEVtGD6kQxBTfi_nsFxrVMKsBcE-VfwmB3g";

axios.defaults.baseURL = baseURL;
axios.defaults.withCredentials = true;
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=utf-8'
// axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
export { baseURL }

function setToken() {
    const token = localStorage.getItem('token');
    if (token != null) {
        // localStorage.getItem('token')||
        axios.defaults.headers.common['Authorization'] = token;
    }
    // axios.defaults.headers.common['Client-sn'] = localStorage.getItem("currentSn")||''
    axios.defaults.headers.common['Authorization'] = token;
}

export function request_get(url, param, callback) {
    setToken();
    axios.get(url, { params: param }).then((response) => {
        if (response.data.code == 401) {
            MessageBox.confirm("登陆已过期,是否前往重新登陆?", "提示").then(res => {
                window.location.href = '/#/login'
            })
            Vue.$emit('logout')
            localStorage.removeItem('userName')
            localStorage.removeItem('token')
            callback(response.data)
            return
        }
        callback(response.data);
    }).catch(err => {
        console.log(err, 'get_');
        checkToken();
    })
}

export function request_post(url, data, callback) {
    setToken();

    axios.post(url, data).then((response) => {
        callback(response.data);
    }).catch(err => {
        if (err.response.status == 401) {
            // console.log("token过期");
            window.location.href = '/#/login'
        }
        checkToken();
    })
}

export function request_delete(url, callback) {
    setToken();
    axios.delete(url).then((response) => {
        callback(response.data);
    }).catch(err => {
        console.log(err);

        checkToken();
    })
}

export function request_sync(url, data, requestType) {
    return requestSync(url, data, requestType);
}

export default function requestSync(url, data, requestType) {
    setToken();
    let promise;
    return new Promise((resolve, reject) => {
        if (requestType == 'get' || requestType == "delete") {
            promise = requestType == "get" ? axios.get(url) : axios.delete(url);
        } else {
            promise = axios.post(url, qs.stringify(data))
        }
        promise.then((res) => {
            resolve(res.data)
        }).catch((err) => {
            reject(err);
        })
    })
}

function checkToken() {
    // axios.get("/api/user/currentUser").then(function (data) {
    // }).catch(err => {
    //     localStorage.removeItem('token');
    //     localStorage.removeItem('user');
    //     location.reload();
    // })
}

// 指定携带token请求
function userToken(utoken) {
    if (utoken != null) {
        axios.defaults.headers.common['Authorization'] = "Bearer " + utoken;
    }
}

export function request_uget(url, utoken, callback) {
    userToken(utoken);
    axios.get(url).then((response) => {
        callback(response.data);
    }).catch(err => {
        console.log(err);
        checkToken();
    })
}

export function request_put(url, data, callback) {
    setToken();
    axios.put(appendJsonToUrl(url, data), data).then((response) => {
        callback(response.data);
    }).catch(err => {
        console.log(err);
        checkToken();
    })
}
export function request_upost(url, utoken, data, callback) {
    userToken(utoken);
    axios.post(url, qs.stringify(data)).then((response) => {
        callback(response.data);
    }).catch(err => {
        console.log(err);
        checkToken();
    })
}

export function request_udelete(url, utoken, callback) {
    userToken(utoken);
    axios.delete(url).then((response) => {
        callback(response.data);
    }).catch(err => {
        console.log(err);
        checkToken();
    })
}

export function request_usync(url, utoken, data, requestType) {
    return urequestSync(url, utoken, data, requestType);
}

export function urequestSync(url, utoken, data, requestType) {
    userToken(utoken);
    let promise;
    return new Promise((resolve, reject) => {
        if (requestType == 'get' || requestType == "delete") {
            promise = requestType == "get" ? axios.get(url) : axios.delete(url);
        } else {
            promise = axios.post(url, qs.stringify(data))
        }
        promise.then((res) => {
            resolve(res.data)
        }).catch((err) => {
            reject(err);
        })
    })
}
export function appendJsonToUrl(url, json) {
    let params = new URLSearchParams();
    for (let key in json) {
        params.append(key, json[key]);
    }
    return url + '?' + params.toString();
}

